module.exports = __webpack_public_path__ + "static/media/Birthday.ea275165.jpeg";